import { convertValueToLocale } from "helpers/convertValueToLocale";

export const getLoanChartTitle = (
  activePosition,
  energyEfficiencyClass,
  conclusionsPro
) => {
  const { loanConclusions } = conclusionsPro;

  if (energyEfficiencyClass?.label === "QNG") {
    return `Dein Vorteil in den ersten ${activePosition} Jahren: ca. ${convertValueToLocale(
      loanConclusions.loanInterestDifferenceNegative[activePosition]
    )}.`;
  }

  if (energyEfficiencyClass?.label === "KW") {
    return `Dein Vorteil: ca. ${convertValueToLocale(
      loanConclusions.loanInterestDifferenceNegative[activePosition]
    )} Ersparnis. Dir entgehen aber ca. ${convertValueToLocale(
      loanConclusions.loanInterestDifferencePositive[activePosition]
    )} im Vergleich zu QNG.`;
  }

  return `Dir entgeht der Vorteil von ca. ${convertValueToLocale(
    loanConclusions.loanInterestDifferencePositive[activePosition]
  )} in den ersten ${activePosition} Jahren im Vergleich zu QNG.`;
};

export const getLoanChartDescription = (energyEfficiencyClass) => {
  if (energyEfficiencyClass?.label === "QNG") {
    return `Weil Dein Objekt den höchsten Energiestandard (QNG) erfüllt, erhältst
     du den maximalen KfW-Förderkredit von 150.000 €. Die Kombination dieses
      günstigeren Kredits mit der Hauptfinanzierung senkt deine Zinskosten erheblich.`;
  }

  if (energyEfficiencyClass?.label === "KW") {
    return `Dein Objekt erfüllt den KFN-Standard und sichert Dir so einen KfW-Förderkredit von 100.000 €.
     Die Kombination dieses günstigeren Kredits mit der Hauptfinanzierung führt zu deiner Ersparnis.`;
  }

  return `Die Finanzierung erfolgt zu normalen Marktkonditionen, da das Objekt keine KfW-Förderung
   erhält. Dadurch zahlst Du im Vergleich zu geförderten Objekten höhere Zinsen.`;
};

export const getEarlySaleProfit = ({
  proCalculationCharts,
  activePosition,
}) => {
  return convertValueToLocale(
    proCalculationCharts?.investmetAnalysisChart?.earlySaleProfit[
      activePosition
    ]
  );
};

export const getTotalTaxSavings = ({
  proCalculationCharts,
  activePosition,
}) => {
  return convertValueToLocale(
    proCalculationCharts?.taxSavingsChart?.totalTaxSavings?.[activePosition]
  );
};

export const getAquisitionsPrice = (costsChart) => {
  return convertValueToLocale(
    costsChart.totalCosts -
      costsChart.details.find(
        (item) => item.name === "investObjectPriceWithFurniture"
      )?.value || 0
  );
};

export const getTotalInvestment = ({
  proCalculationCharts,
  activePosition,
}) => {
  return convertValueToLocale(
    proCalculationCharts?.investmentAccChart?.investmentAcc?.[activePosition]
  );
};
